import {useFactoryFetch} from "@/composables/useFactoryFetch.ts";
import {API_URLS} from "@/utils/constants/api-urls.ts";
import {AfterFetchContext, MaybeRefOrGetter} from "@vueuse/core";
import {IGetResult, IUser, QueryFilter} from "@/types/api.ts";
import {useAxios} from "@vueuse/integrations/useAxios";
import {axiosInstance} from "@/composables/axiosInstance.ts";
import {toValue} from "vue";

export class AdminService {
  static getInstance(): AdminService {
    return new AdminService();
  }

  getDashboardOverview() {
    return useFactoryFetch(API_URLS.admin.dashboardOverview, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.data}
      }
    }).json();
  }

  async forceUserToLogout(user: IUser): Promise<IUser> {
    const {execute, data} = useAxios<IGetResult>(API_URLS.admin.forceUserToLogout(user._id), {
      method: "POST",
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data;
  }

  async updateUsers(usersToUpdate: IUser[]) {
    const {execute, data} = useAxios<IGetResult>(API_URLS.admin.updateUsers, {
      method: "POST",
      data: {users: usersToUpdate}
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data;
  }

  async generateNextIds():Promise<string[]> {
    const {execute, data} = useAxios<IGetResult>(API_URLS.admin.generateNextId, {
      method: "GET"
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data;
  }

  async getUsers(query?: MaybeRefOrGetter<QueryFilter<IUser>>): Promise<IUser[]> {
    let q = toValue(query);
    const list = API_URLS.users.list;
    const dt: string = typeof list === "function" ? list(q) : list;
    const {execute, data} = useAxios<IGetResult>(dt, {
      method: "GET"
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data;
  }
}